module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row form-item"
  }, [_c('div', {
    class: ("col-sm-" + (_vm.type.left) + " rowTitle")
  }, [(_vm.isRequired) ? _c('span', {
    staticClass: "required-content"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    class: ("col-sm-" + (_vm.type.right))
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7175face","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content-block/index.vue
// module id = 498
// module chunks = 0